import { tenantType } from "@agentcall/core/type"
import { Select } from "@/components/ui/select"

const usageOptions = tenantType.TENANT_PURPOSES.map((item) => ({
  value: item.key,
  label: item.value,
}))

interface TenantUsageSelectorProps {
  value: string
  onChange: (value: string) => void
  error?: string
  placeholder?: string
  disabled?: boolean
  className?: string
}

export function TenantUsageSelector({
  value,
  onChange,
  error,
  placeholder = "選択してください",
  disabled = false,
  className,
}: TenantUsageSelectorProps) {
  return (
    <div className={className}>
      <Select
        value={value}
        onChange={onChange}
        options={usageOptions}
        placeholder={placeholder}
        disabled={disabled}
        className="w-full"
      />
      {error && <p className="text-xs text-red-500 mt-1">{error}</p>}
    </div>
  )
}
